<template lang="pug">
.request-detail-modal
  //- b-modal(v-model="_modalShow" size="lg" no-close-on-backdrop no-close-on-esc @ok="onUpdate")
  b-modal(v-model="_modalShow" size="lg" no-close-on-backdrop no-close-on-esc)
    template(#modal-title)
      //- span(v-if="request && request.reply") {{ request.facilityName }}

    .register-body(v-if="request && request.reply")
      FormLabel(v-if="request.reply.acceptance" key-name="受け入れ可否" :value="convertAcceptanceText(request.reply.acceptance)")
      FormLabel(key-name="返信内容" :value="request.reply.messageText")
      
    .register-body(v-if="request && !request.reply")
      span.error-message 返信されていません

    template(#modal-footer="{ ok, cancel }")
      .buttons
        //- button.btn.modal-ok-btn(type="button" @click="ok()") OK
        button.btn.modal-cancel-btn(type="button" @click="cancel()") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { OtherOfficeAcceptanceRequestsGetModel } from "@/commons/services/OtherOfficeAcceptanceRequests";

import FormLabel from "@/pc/components/forms/FormLabel.vue";
import { Acceptance } from "@/commons/services/OtherOfficeAcceptanceRequestReplies";

/**
 * ### リクエスト返信詳細モーダル
 */
@Component({
  components: {
    FormLabel
  }
})
export default class RequestReplyDetailModal extends Vue {
  /** モーダル表示可否 */
  @Prop()
  value!: boolean;
  /** 表示対象のリクエスト */
  @Prop()
  request!: OtherOfficeAcceptanceRequestsGetModel;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  convertAcceptanceText(acceptance: Acceptance): string {
    switch (acceptance) {
      /** 受け入れ可 */
      case Acceptance.POSSIBLE: {
        return "受け入れ可";
      }
      /** 詳細相談希望 */
      case Acceptance.NEED_CONSULTATION: {
        return "詳細相談希望";
      }
      /** 受け入れ不可 */
      case Acceptance.NOT_POSSIBLE: {
        return "受け入れ不可";
      }
      default: {
        return "";
      }
    }
  }

  /**
   * ### 更新ボタン押下処理
   *
   * - メッセージ内容の更新を親コンポーネントに通知する
   * - TODO その場合、テキスト入力欄を用意する必要がある
   * - モーダルを非表示にするか否かは親コンポーネントに移譲する
   */
  // onUpdate(modalEvent: any): void {
  //   modalEvent.preventDefault();
  //   this.$emit("onUpdate");
  //   return;
  // }
}
</script>
